import React, { ReactNode } from "react";

import { css } from "@emotion/core";

import {
  Spacer,
  Colors as ThemeColors,
  Typography,
} from "@zapier/design-system";

import { breakpoints } from "@zapier/checkout/esm/constants";

type Props = {
  children: ReactNode;
  title?: string;
};

const headingCss = css`
  ${Typography.sectionHeader3Bold};
  color: ${ThemeColors.neutral800};
  margin: 3rem 0;
  padding: 0;
  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    margin: 2rem 0;
  }
`;

const sectionCss = css`
  margin-bottom: 2em;
`;

export const CheckoutSection = (props: Props) => {
  return (
    <section css={sectionCss}>
      {props.title ? (
        <h2 css={headingCss}>{props.title}</h2>
      ) : (
        <Spacer height="3rem" />
      )}
      {props.children}
    </section>
  );
};
